import { InputDropdownItem } from '@platform/components';
import { ApplicationPageProps } from '../../Application';
import { ReferralSelection } from '../shared/ReferralSelection';

const EY_REFERRAL_OPTIONS: InputDropdownItem[] = [
	{ text: 'A colleague within your company', textValue: 'A colleague within your company' },
	{ text: 'Your manager', textValue: 'Your manager' },
	{ text: 'Your Global CSR leader', textValue: 'Your Global CSR leader' },
	{ text: 'Your Regional CSR leader', textValue: 'Your Regional CSR leader' },
	{
		text: 'Email communication from your company',
		textValue: 'Email communication from your company',
	},
	{ text: 'Internal meeting or town hall', textValue: 'Internal meeting or town hall' },
	{
		text: 'An internal organization tool or website',
		textValue: 'An internal organization tool or website',
	},
	{ text: 'LinkedIn', textValue: 'LinkedIn' },
	{ text: 'Other', textValue: 'Other' },
];

export const EYReferralSelection = (props: ApplicationPageProps) => {

	return (
		<ReferralSelection
			{...props}
			referralOptions={EY_REFERRAL_OPTIONS}
		/>
	);
};
